import { getIsFavourite } from 'redux/modules/favourites-products/selectors';
import { getProductByLineNumber } from 'redux/modules/entities/selectors/products';
import { getPromotionDescription } from 'redux/modules/entities/selectors/promotions';

import isAmendOrder from 'redux/modules/trolley/selectors/amending-order';

import { isDefined } from 'utils/validation';

const isWeightedProductQuantityDelta = (quantityAmount, reservedQuantity) => {
  if (quantityAmount < reservedQuantity) {
    return -1;
  }
  if (quantityAmount > reservedQuantity) {
    return 1;
  }
  return 0;
};

const yesOrNo = expression => (expression ? 'YES' : 'NO');

function calculateProductAmounts(trolleyItem, productPricePerUnit, isAmend) {
  const quantityAmount = trolleyItem?.quantity?.amount;
  const retailUomType = trolleyItem?.quantity?.uom;
  const reservedQuantity = trolleyItem?.reservedQuantity;
  const trolleySalePrice = trolleyItem?.price?.amount;

  const trolleyPricePerUnit =
    trolleySalePrice > 0 && quantityAmount > 0
      ? Math.round((trolleySalePrice / quantityAmount) * 100) / 100
      : 0;

  const retailUomPrice = trolleyItem?.retailPrice?.price?.amount;

  const isWeighted = retailUomType !== 'C62';
  const pricePerUnit = trolleyPricePerUnit || productPricePerUnit;

  let quantityDelta = quantityAmount - reservedQuantity;
  const delta = isWeighted
    ? isWeightedProductQuantityDelta(quantityAmount, reservedQuantity)
    : quantityDelta;

  if (retailUomType === 'GRM') {
    quantityDelta /= 1000;
  }

  const absolutePrice = Math.abs(retailUomPrice * quantityDelta);
  const priceIfWeighted = Number.isNaN(absolutePrice) ? undefined : absolutePrice;
  const productAmounts = {
    price: isWeighted ? priceIfWeighted : pricePerUnit,
    quantity: isWeighted ? 1 : quantityAmount,
    amendmentQuantityDelta: isAmend ? delta : undefined,
  };
  return productAmounts;
}

const trolleyItemToAnalyticsProduct = state => trolleyItem => {
  const isAmend = isAmendOrder(state);
  const lineNumber = trolleyItem?.lineNumber;

  const {
    brandName,
    categories = [],
    name,
    productType,
    promotions = [],
    currentSaleUnitPrice: { price: { amount: productPricePerUnit } = {} } = {},
    sponsored,
    sponsorshipId,
  } = getProductByLineNumber(state, lineNumber) ?? {};

  const promotionDescription =
    promotions.map(promotionId => getPromotionDescription(state, promotionId))?.[0] || undefined;
  const customerFavourite = getIsFavourite(state, lineNumber);
  const favourite = isDefined(customerFavourite) ? yesOrNo(customerFavourite) : undefined;
  const sponsoredSource = sponsorshipId ? 'citrus_ad' : 'aem';

  const productAmounts = calculateProductAmounts(trolleyItem, productPricePerUnit, isAmend);

  return {
    id: lineNumber,
    name,
    category: categories?.map(category => category.name),
    variant: productType,
    brand: brandName,
    favourite,
    quantity: productAmounts.quantity,
    price: productAmounts.price,
    offer: promotionDescription,
    amendment_quantity_delta: productAmounts.amendmentQuantityDelta,
    sponsored: yesOrNo(sponsored),
    sponsored_source: sponsored ? sponsoredSource : 'unknown',
  };
};

export default trolleyItemToAnalyticsProduct;
